import { AxiosErrorHandler, Card, Col, InfinityLoading, Loading, Row, withErrorBoundary } from 'ui';
import { ContentObjectFeedEmptyState } from '../content-object-feed';
import { ContentObjectRenderer } from '../content-object-renderer';
import { useFeedInfiniteQuery } from '../queries';

const MainFeed = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isLoading } = useFeedInfiniteQuery({
    pagination: { pageSize: 7 },
  });

  const items = data?.pages.flat().flat();

  return (
    <AxiosErrorHandler error={error}>
      {isLoading || !items ? (
        <Loading />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      items.length === 0 ? (
        <ContentObjectFeedEmptyState />
      ) : (
        <Row gutter={[0, 'ms']}>
          {items.map((item) => (
            <Col key={item.id} span={24}>
              <Card marginBottom={false}>
                <ContentObjectRenderer item={item} key={item.id} view="feed" />
              </Card>
            </Col>
          ))}
          <Col justifyContent="center" span={24}>
            <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
          </Col>
        </Row>
      )}
    </AxiosErrorHandler>
  );
};

export default withErrorBoundary(MainFeed);
